import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="pt-40 pb-24 px-6 md:px-10 min-h-[70svh]" data-testid="payment-cancel-page">
      <div className="overline mb-6">Ξ 008 — Aborted</div>
      <h1 className="font-display uppercase text-5xl md:text-7xl tracking-tight leading-[0.9]">
        Channel closed.<br />No charge made.
      </h1>
      <p className="mt-8 text-[#888] max-w-lg">You cancelled checkout. Your cart is still intact — pick up where you left off.</p>
      <div className="mt-12 flex gap-4">
        <Link to="/cart" className="btn-vault">Back to cart</Link>
        <Link to="/" className="btn-ghost">Home →</Link>
      </div>
    </div>
  );
}
